import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingActions } from "./WhatsAppFloat";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
};
